module.exports = __webpack_public_path__ + "static/media/Fanolly LION.8e28b915.png";